import { Analytics } from './analytics';
import { ItemRefineSearchAction } from '../item_refine_search/item_refine_search_action';

/// Adobe Analytics 非同期サイト内検索ページング用送信クラス
export class AsyncSearchKeywordPagingAnalytics extends Analytics {
    constructor() {
        super();
        ItemRefineSearchAction.SEND_IN_SITE_SEARCH_PAGING_EVENT.on((data) => {
            this.run(() => {
                const linkAnalyticsData = {
                    server: 'club/pc',
                    fName: 'キーワード検索結果_ページング_非同期',
                    events: ['event2', 'event14'],
                    exclusionKeyword: window.analyticsData.exclusionKeyword,
                    searchKeyword: window.analyticsData.searchKeyword,
                    listDisplayType: window.analyticsData.listDisplayType,
                    paging: window.analyticsData.paging,
                    variationCode: window.analyticsData.variationCode,
                    supplierID: window.analyticsData.supplierID,
                    sortType: window.analyticsData.sortType,
                    searchCondition: window.analyticsData.searchCondition,
                    searchSpecCondition: window.analyticsData.searchSpecCondition,
                    searchHitItemCount: window.analyticsData.searchHitItemCount,
                    club: {
                        server: 'club/pc',
                        prop5: 'キーワード検索結果_ページング_非同期',
                        events: ['event2', 'event14'],
                        prop16: window.analyticsData.club.prop16,
                        prop18: window.analyticsData.club.prop18,
                        prop19: window.analyticsData.club.prop19,
                        prop51: window.analyticsData.club.prop51,
                        prop52: window.analyticsData.club.prop52,
                        prop57: window.analyticsData.club.prop57,
                        eVar115: window.analyticsData.club.eVar115
                    },
                    soloel: {
                        server: 'soloel/pc',
                        prop5: 'キーワード検索結果_ページング_非同期',
                        events: ['event2'],
                        prop16: window.analyticsData.soloel.prop16,
                        prop18: window.analyticsData.soloel.prop18,
                        prop19: window.analyticsData.soloel.prop19,
                        prop51: window.analyticsData.soloel.prop51,
                        prop52: window.analyticsData.soloel.prop52,
                        prop53: window.analyticsData.soloel.prop53,
                        prop57: window.analyticsData.soloel.prop57,
                        eVar78: window.analyticsData.soloel.eVar78
                    }
                };

                window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
            });
        });
    }
}
